module.exports = __webpack_public_path__ + "img/mz.d5ea00fd.svg";